import { render, staticRenderFns } from "./mainGroup.vue?vue&type=template&id=edc480cc"
import script from "./mainGroup.vue?vue&type=script&lang=js"
export * from "./mainGroup.vue?vue&type=script&lang=js"
import style0 from "./mainGroup.vue?vue&type=style&index=0&id=edc480cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports